import {memo} from "react";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Tài chính tổng quan cho Dashboard CEO.
 * Dữ liệu: dashboardApi.ceoFinance() = { revenueTotal, expenseTotal, profit, expensesByCategory[] }.
 */
function FinanceWidget({
	data,
	loading = false,
	title = 'Tài chính',
	gradient = 'linear-gradient(135deg, #047857 0%, #059669 60%, #34d399 100%)',
}) {

	const revenueTotal = data?.revenueTotal || 0;
	const expenseTotal = data?.expenseTotal || 0;
	const profit       = data?.profit ?? (revenueTotal - expenseTotal);
	const categories   = data?.expensesByCategory || [];

	const stat = (label, value, color) => (
		<div style={{flex: 1, textAlign: 'center', padding: '4px 6px'}}>
			<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{label}</p>
			<p style={{fontSize: 16, fontWeight: 700, color, margin: '2px 0 0'}}>{numberFormat(value)}</p>
		</div>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(5,150,105,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader icon="fa-light fa-coins" title={title} gradient={gradient} />
			<div style={{padding: '14px 18px'}}>
				{loading
					? <div style={{textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '12px 0'}}>Đang tải...</div>
					: (
						<>
							<div style={{display: 'flex', alignItems: 'stretch', gap: 4, marginBottom: 14}}>
								{stat('Thu', revenueTotal, '#059669')}
								<div style={{width: 1, background: '#e2e8f0'}} />
								{stat('Chi', expenseTotal, '#ef4444')}
								<div style={{width: 1, background: '#e2e8f0'}} />
								{stat('Lợi nhuận', profit, profit >= 0 ? '#0284c7' : '#ef4444')}
							</div>

							{categories.length > 0 && (
								<div style={{borderTop: '1px dashed #e2e8f0', paddingTop: 10}}>
									<p style={{fontSize: 11, color: '#94a3b8', margin: '0 0 8px'}}>Chi theo nhóm</p>
									{categories.map((cat, index) => (
										<div key={`exp-cat-${index}`} style={{
											display: 'flex', justifyContent: 'space-between',
											fontSize: 12, padding: '3px 0', color: '#475569',
										}}>
											<span><FontAwesomeIcon icon="fa-light fa-circle-small" style={{marginRight: 6, color: '#cbd5e1'}} />{cat.name}</span>
											<b style={{color: '#ef4444'}}>{numberFormat(cat.total)}</b>
										</div>
									))}
								</div>
							)}
						</>
					)
				}
			</div>
		</div>
	);
}

export default memo(FinanceWidget);
